export function featureInSection(sections, section, attributeKey) {
	//console.log('featureInSection', section.features, section, attributeKey);
	let featuresWithAssignedSections = [];
	if (section.features === null) {
		sections.forEach(s => {
			featuresWithAssignedSections = Array.from(new Set(featuresWithAssignedSections.concat(s.features)));
		});
		//console.log('featuresWithAssignedSections', featuresWithAssignedSections);
		return !featuresWithAssignedSections.includes(attributeKey);
	} else {
		return section.features?.includes(attributeKey);
	}
}
